// Directly reference and pull in styling from stub,
// that is commented out in production to elimited 'fake'
// stub javascript while having single source of truth for LESS
//require("../stubs/orderConfigurationDetail/orderConfigurationDetail.less");

import $ from 'jquery';
import run from '../../utilities/run';
import {setElementsFromScope} from "../../utilities/selectorHelpers";
import {calculateCutOffTime} from './utilities';

run("#order-config-detail", ()=>{
	const el = $("#order-config-detail");
  	orderConfigurationDetail(el);
});

function orderConfigurationDetail(el){
	const internalOrderGracePeriod = el.data("detail-internal-order-domain");
    const channelOrderGracePeriod = el.data("detail-channel-order-domain");
    const defaultAddressValidationLevels = el.data("detail-default-address-validation-levels");
    const defaultDomesticShippingMethods  = el.data("detail-default-domestic-shipping-methods");
    const rtlAddressValidationLevel = el.data("retailer-address-validation-level");
    const rtlDefaultShippingMethod = el.data("retailer-default-shipping-method");
    const orderSplit = el.data("order-split");
    const orderInsufficientInventory = el.data("order-insufficient-inventory");
    const els = {};

 const elementsMap = {
    internalGracePeriodHours: ".internalGracePeriodHours",
    internalGracePeriodMinutes: ".internalGracePeriodMinutes",
    interalOrderCutOffTime: "#interalOrderCutOffTime",

    channelGracePeriodHours: ".channelGracePeriodHours",
    channelGracePeriodMinutes: ".channelGracePeriodMinutes",
    channelOrderCutOffTime: "#channelOrderCutOffTime",
 
  };

function setElements(){
    setElementsFromScope(els, elementsMap, el);
}

onLoad();

function onLoad(){
	setElements();
	setInternalGracePeriod();
	setChannelOrderGracePeriod();
}


function setInternalGracePeriod(){
	let hours="";
	let minutes="";
	if((!(typeof internalOrderGracePeriod.cdmValue === "undefined")) || !internalOrderGracePeriod.cdmValue===""){
		hours=parseInt(internalOrderGracePeriod.cdmValue/60);
		minutes=internalOrderGracePeriod.cdmValue%60;
		els.internalGracePeriodHours.text(hours);
		els.internalGracePeriodMinutes.text(minutes);
		els.interalOrderCutOffTime.text(calculateCutOffTime(hours, minutes));
		if(hours == 18){
		 	minutes = 0;
		 	els.internalGracePeriodMinutes.text(minutes);
		 	els.interalOrderCutOffTime.text(calculateCutOffTime(hours, minutes));
		 }

		  if(minutes > 0 && hours == 18){
		  	hours = 17;
		  	els.internalGracePeriodHours.text(hours);
		  	els.interalOrderCutOffTime.text(calculateCutOffTime(hours, minutes));
		  }

	}else{
		hours=0;
		minutes=0;
		els.internalGracePeriodHours.text(hours);
		els.internalGracePeriodMinutes.text(minutes);
		els.interalOrderCutOffTime.text(calculateCutOffTime(hours, minutes));
	}
	
}

function setChannelOrderGracePeriod(){
	let hours="";
	let minutes="";
	if((!(typeof channelOrderGracePeriod.cdmValue === "undefined")) || !channelOrderGracePeriod.cdmValue===""){
		hours=parseInt(channelOrderGracePeriod.cdmValue/60);
		minutes=channelOrderGracePeriod.cdmValue%60;
		els.channelGracePeriodHours.text(hours);
		els.channelGracePeriodMinutes.text(minutes);
		els.channelOrderCutOffTime.text(calculateCutOffTime(hours, minutes));

		if(hours == 18){
			minutes = 0;
			els.channelGracePeriodMinutes.text(minutes);
			els.channelOrderCutOffTime.text(calculateCutOffTime(hours, minutes));
		}

		if(minutes > 0 && hours == 18){
			hours = 17;
			els.channelGracePeriodMinutes.text(minutes);
			els.channelOrderCutOffTime.text(calculateCutOffTime(hours, minutes));
		}
	}
	
}


	
}


// WEBPACK FOOTER //
// ./src/pages/orderConfiguration/orderConfigurationDetailsPage.js